/**
 * Okta IdP-initiated OIDC (dashboard tile) sends users to the Initiate Login URI with ?iss=.
 * @see https://support.okta.com/help/s/article/develop-a-custom-openid-connect-application-that-can-support-sso-when-launched-from-the-okta-dashboard
 */
export function isTrustedIdpInitiatedIss(
  issParam: string | null,
  configuredIssuer: string | undefined
): boolean {
  if (!issParam || !configuredIssuer) return false;
  try {
    return new URL(issParam).origin === new URL(configuredIssuer).origin;
  } catch {
    return false;
  }
}
